import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import PdpSharedDetailAttributeLink from './helpers/PdpSharedDetailAttributeLink';

// helpers
import get from 'lodash.get';

function PdpSharedDetailOrigin({ item }) {
    if (!get(item, 'attributes.origin[0].option.name')) {
        // Legacy Value for items without origin attribute
        return <span data-tn="pdp-spec-origin">{get(item, 'classification.countryOfOrigin')}</span>;
    }

    return (
        <PdpSharedDetailAttributeLink
            item={item}
            dataTn="pdp-spec-origin"
            attributes={get(item, 'attributes.origin')}
        />
    );
}

PdpSharedDetailOrigin.propTypes = {
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpSharedDetailOrigin, {
    item: graphql`
        fragment PdpSharedDetailOrigin_item on Item {
            ...PdpSharedDetailAttributeLink_item
            classification {
                countryOfOrigin
            }
            attributes {
                origin {
                    ...PdpSharedDetailAttributeLink_attributes
                    option {
                        name
                    }
                }
            }
        }
    `,
});
